import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/lib/custom-validators';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { MemberService } from 'src/app/services/member.service';

@Component({
  selector: 'app-create-administrator',
  templateUrl: './create-administrator.component.html',
  styleUrls: ['./create-administrator.component.scss']
})
export class CreateAdministratorComponent implements OnInit {
  public administratorForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<any>,
    private _notify: NotificationService,
    private _user: MemberService
  ) {
    this.administratorForm = new FormGroup({
      first_name: new FormControl('', [Validators.required]),
      last_name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, CustomValidators.validateEmailAddress]),
      password: new FormControl('',[Validators.required, Validators.minLength(8), CustomValidators.patternValidator(/\d/, { hasNumber: true }), CustomValidators.patternValidator(/[A-Za-z]/, { hasLetters:true })])
    });
  }

  cancel(){
    this.dialogRef.close(false);
  }

  submit(){
    if(this.administratorForm.get('first_name').status=="INVALID") return this._notify.showMessage('First name is required.', 'OK');
    if(this.administratorForm.get('last_name').status=="INVALID") return this._notify.showMessage('Last name is required.', 'OK');
    if(this.administratorForm.get('email').status=="INVALID") return this._notify.showMessage('A valid email address is required.', 'OK');
    if(this.administratorForm.get('password').status=="INVALID") return this._notify.showMessage('An alphanumeric password of at least 8 characters is required.', 'OK');
    let administrator={};
    administrator['first_name']=this.administratorForm.get('first_name').value;
    administrator['last_name']=this.administratorForm.get('last_name').value;
    administrator['email']=this.administratorForm.get('email').value;
    administrator['password']=this.administratorForm.get('password').value;
    this._user.createAdministrator(administrator).subscribe(
      res=>{
        if(res.message=='success') {
          this._notify.showMessage('New administrator created.','OK');
          this.dialogRef.close(true);
        } else {
          console.log(res);
          this._notify.showMessage('There was an error, check the log for details.','OK');
        }
      }
    );
  }

  ngOnInit() {
  }

}
